export const TOTAL_YEARLY_CONTRIBUTION = 20000;
